import { render } from "./FloatingInput.vue?vue&type=template&id=2ba2083c"
import script from "./FloatingInput.vue?vue&type=script&lang=js"
export * from "./FloatingInput.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__